import styled from 'styled-components';

export const ContainerFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
